export default "__VITE_ASSET__CQCIjiKC__"